import React from 'react';
import Carousel from './Carousel';
import StatsSection from '../pages/StatsSection';
import AboutSection from '../pages/About';
import StepTowardsSection from '../pages/StepTowardsSection';
import VehicleFleet from '../pages/VehicleFleet ';
import WhyChooseUs from '../pages/WhyChooseUs';
import CategoriesSection from '../pages/CategoriesSection';
import HowItWorks from '../pages/HowItWorks';
import TestimonialSection from '../pages/TestimonialSection';
import BlogSection from '../pages/BlogSection';





const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
<Carousel/>
<StatsSection/>
<AboutSection/>
<StepTowardsSection/>
<VehicleFleet/>
<WhyChooseUs/>
<CategoriesSection/>
<HowItWorks/>
<TestimonialSection/>
<BlogSection/>

    </div>
  );
};

export default HeroSection;
